module.exports = __webpack_public_path__ + "img/mf.24841de9.svg";